<template>
  <div class="round-checkbox" :class="{ left: textLeft }">
    <label class="switch">
      <input type="checkbox" @click="emitClick" :checked="checked">
      <span class="slider round"></span>
    </label>

    <slot />
  </div>

</template>

<script>
export default {
  name: 'PaymentLinkRoundCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    textLeft: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .round-checkbox {
    display: flex;
    gap: 16px;
    align-items: center;

    &.left {
      flex-direction: row-reverse;
    }
  }

  .switch {
    -webkit-tap-highlight-color: transparent;
    position: relative;
    display: inline-block;
    max-width: 56px;
    min-width: 56px;
    height: 32px;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $gray-300;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    left: 4px;
    bottom: 4px;
    background-color: $white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: $primary-500;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px $primary-500;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
